import * as React from 'react';
import * as Dictionary from 'Models/Dictionary';
import {WrappedFieldProps} from 'redux-form';
import * as AlertModule from 'Modules/AlertModule';
import {withTranslation} from 'react-i18next';

type Props = {
    label: string;
    type: string;
    max?: number;
    min?: number;
    disabled: boolean;
    options: Array<AlertModule.Types.DomainOfInterestDto>;
    t?: Function;
    onDelete: Function;
    showList: () => Function;
};

class DomainOfIntrestSelect extends React.PureComponent<WrappedFieldProps & Props> {
    public handleClick(value) {
        // if (this.props.disabled) {
        //     return null;
        // } else {
        //     this.props.input.onChange(value);
        // }
    }

    public handleDelete(zone: AlertModule.Types.DomainOfInterestDto) {
        this.props.onDelete(zone);
    }

    public render() {
        const {input, meta, label, disabled, t, showList} = this.props;
        return (
            <div className="assign">
                <label htmlFor={input.name} className="form-field__label">{label}</label>
                <div className="assign__control">
                    <div className="assign-item__image-wrapper"/>
                    <div className="assign-item__title-1">
                        <span>{t('carDetails:zoneType')}</span>
                    </div>
                    <div className="assign-item__title-2">
                        <span>{t('address')}</span>
                    </div>
                    <div className="assign-item__delete"/>
                </div>
                {Array.isArray(input.value) && input.value.length > 0 &&
                <div className="form-field form-field--expand mt-10">
                    {input.value.map((element: AlertModule.Types.DomainOfInterestDto, idx) => {
                        return (
                            <div
                                key={`${element}-${idx}`}
                                className="assign-item assign-item--border"
                                onClick={() => this.handleClick(element.id)}
                            >
                                <div className="assign-item__image-wrapper">
                                    <img src={Dictionary.ZoneTypeIcons.get(element.domainOfInterestType)}
                                         alt="" className="assign-item__img"/>
                                </div>
                                <div className="assign-item__title-1">{element.title}</div>
                                <div className="assign-item__title-2">{element.address}</div>
                                <div className="assign-item__delete">
                                    <i className="icon--plus_sign rotate-45deg"
                                       onClick={() => this.handleDelete(element)}/>
                                </div>
                            </div>
                        );
                    })
                    }
                </div>
                }
                {(meta.touched &&
                    (meta.error && (
                        <div className="form_field--error_wrapper">
                            <span className="form_field--error">{meta.error}</span>
                        </div>
                    ))) ||
                (meta.warning && <span>{meta.warning}</span>)}

                <p className="flex flex--center mt-10 font-xmd">
                    <span className="mr-7">{t('addZone')}</span>
                    <i className="icon--plus_sign" onClick={showList}/>
                </p>
            </div>
        );
    }
}

export default withTranslation(['forms', 'errors', 'carDetails'])(DomainOfIntrestSelect as React.ComponentType<any>) as React.ComponentClass<any>;



// WEBPACK FOOTER //
// ./src/components/Layout/Form/Fields/DomainOfIntrestSelect.tsx